import React from "react";
import { PageHeader, StagePage } from "src/stage/StageUi";
import WhatsAppConnectionSettings from "../WhatsAppConnectionSettings/WhatsAppConnectionSettings";

// AUTO-WA-39: first-run connection inside the Stage frame.
function Setup() {
  return (
    <StagePage label="Connect WhatsApp">
      <PageHeader
        eyebrow="Get started"
        title="Connect WhatsApp"
        description="Choose your organisation’s WhatsApp Business account and number. Your whole team shares this one connection."
      />
      <div className="wa-legacy">
        <WhatsAppConnectionSettings mode="setup" />
      </div>
    </StagePage>
  );
}

export default Setup;
